import type { ReactNode } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { EventsPageShell } from '@/pages/events/components/EventsPageShell';
import { conclaveEventPath } from '@/lib/conclave-paths';

export function ConclaveEventShell({
  children,
  title,
  maxWidthClassName = 'max-w-3xl',
  beforeLeave,
}: {
  children: ReactNode;
  title?: string;
  maxWidthClassName?: string;
  beforeLeave?: (go: (options?: { replace?: boolean }) => void) => void;
}) {
  const { eventId = '', communityId } = useParams();
  const navigate = useNavigate();
  const backTo = conclaveEventPath(eventId, communityId);

  return (
    <EventsPageShell maxWidthClassName={maxWidthClassName} outerClassName="pb-24 md:pb-0">
      <div className="w-full px-2 py-3 sm:px-3 md:px-6 md:py-6 lg:px-8">
        <Button
          variant="ghost"
          className="-ml-1 mb-2 h-9 px-2 text-sm md:mb-4 md:pl-0 md:text-base hover:bg-transparent hover:text-primary"
          asChild
        >
          <Link
            to={backTo}
            onClick={(event) => {
              if (!beforeLeave) return;
              event.preventDefault();
              beforeLeave((options) =>
                navigate(backTo, { ...options, state: { skipLiveRedirect: true } })
              );
            }}
          >
            <ArrowLeft className="mr-1.5 h-4 w-4 md:mr-2" /> Back to event
          </Link>
        </Button>
        {title ? (
          <h1 className="text-xl font-semibold tracking-tight text-foreground md:text-2xl">
            {title}
          </h1>
        ) : null}
        {children}
      </div>
    </EventsPageShell>
  );
}
